import { WorkflowService } from "@/generated";
import { useSpotUser } from "@/utils/spotUser";
import { DATA_KEYS } from "@/utils/useRemoteData";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SpotToast } from "../SpotToast";
import { NoxusIconPicker } from "./NoxusIconPicker";
import { SIZE_MAP } from "../UI/NoxusIcon";

export const WorkflowIconPicker = ({
  flowId,
  icon = "workflow",
  size = "md",
  side = "right",
  align = "end",
  disabled = false,
}: {
  flowId: string;
  icon?: string;
  size?: keyof typeof SIZE_MAP;
  side?: "left" | "right" | "bottom" | "top";
  align?: "start" | "end";
  disabled?: boolean;
}) => {
  const queryClient = useQueryClient();
  const { spotGroup } = useSpotUser();

  const editWorkflowMutation = useMutation({
    mutationFn: WorkflowService.updateWorkflow,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DATA_KEYS.WORKSHOP_RECENT] });

      queryClient.invalidateQueries({ queryKey: [DATA_KEYS.WORKFLOWS_ID] });
      queryClient.invalidateQueries({ queryKey: [DATA_KEYS.WORKFLOWS] });
    },
    onError: () => {
      SpotToast.error("Error updating icon");
    },
  });

  const handleIconClick = (icon: string) => {
    // in case we want to use the picker standalone
    editWorkflowMutation.mutate({
      path: {
        workflow_id: flowId,
        group_id: spotGroup.id,
      },
      body: {
        meta: {
          icon,
        },
      },
    });
  };

  return (
    <NoxusIconPicker
      icon={icon}
      handleClick={handleIconClick}
      size={size}
      side={side}
      align={align}
      disabled={disabled}
    />
  );
};
